<app-header
  [theme]="'secondary'"
  [subTitle]="'nieuws-overzicht-subtitel' | fromDictionary: false"
  [title]="'nieuws-overzicht-titel' | fromDictionary"
></app-header>

<div class="container section-outset-b mt-lg-4" [class.mt-4]="!newestFeaturedItem()">
  @if (newestFeaturedItem(); as featured) {
    <div class="news-container mb-4 mb-md-5">
      <app-news-card class="d-block z-2 position-relative" [news]="featured"></app-news-card>
    </div>
  }

  <ul class="row gutter-y-3 gutter-y-4 gutter-x-4">
    @for (newsItem of newsWithoutFeatured(); track newsItem.id) {
      <li class="col-md-12">
        <app-news-list-card [news]="newsItem"></app-news-list-card>
      </li>
    }

    @if (!news().length && !loaded()) {
      <article class="text-center py-6">
        <div class="text-max-width-xs mx-auto">
          <h2 class="h4 text-secondary">{{ 'nieuws-overzicht-geen-resultaten-titel' | fromDictionary }}</h2>
          <p class="fs-body-md">{{ 'nieuws-overzicht-geen-resultaten-tekst' | fromDictionary }}</p>
        </div>

        <div class="d-flex flex-wrap gap-2 justify-content-center mt-4">
          <a class="button button--secondary" [routerLink]="['/plan-je-bezoek']">
            <span>Plan bezoek</span>
          </a>

          <a class="button button--secondary-subtle" [routerLink]="['/agenda']">
            <span>Bekijk agenda</span>
          </a>
        </div>
      </article>
    }
  </ul>
  @if (newsPage().resultCount > news().length) {
    <div class="text-center mt-4">
      <button class="button button--accent" (click)="loadMoreNews()">
        <span>{{ 'nieuws-overzicht-toon-meer-knoptekst' | fromDictionary }}</span>

        @if (loading()) {
          <app-loading-indicator [loading]="true" [type]="'standalone'"></app-loading-indicator>
        } @else {
          <fstr-icon anchor="line-icon-arrow-down"></fstr-icon>
        }
      </button>
    </div>
  }
</div>
